export const BoxListStyle = {
  listStyleType: "none",
  padding: 0,
};